import { useEffect } from "react";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntries from "./components/CategoryEntries";
import FeaturedWorks from "./components/FeaturedWorks";
import NewsHighlights from "./components/NewsHighlights";
import HotSidebar from "./components/HotSidebar";
import BrandIntro from "./components/BrandIntro";

export default function Home() {
  useEffect(() => {
    document.title = "爱妻艺—精彩影视作品与娱乐资讯平台";
  }, []);

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
        <section className="mb-8">
          <h2 className="mb-4 text-lg font-bold text-foreground-950 md:text-xl">
            <span className="mr-2 inline-block h-5 w-1 translate-y-0.5 rounded-full bg-primary-500"></span>
            分类快捷入口
          </h2>
          <CategoryEntries />
        </section>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
          <div className="flex flex-col gap-6">
            <FeaturedWorks />
            <NewsHighlights />
            <BrandIntro />
          </div>

          <aside className="flex flex-col gap-6">
            <div className="lg:sticky lg:top-24">
              <HotSidebar />
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}